export const domains = {
countries: [
  /*{
    "kod": "PA",
    "nazwa_pl": "Panama",
    "nazwa": "panama",
    "domena": "Panama.com.pl"
  },*/
  {
    "kod": "AL",
    "nazwa_pl": "Albania",
    "nazwa": "albania",
    "domena": "Albania.info.pl"
  },
  {
    "kod": "BH",
    "nazwa_pl": "Bośnia",
    "nazwa": "bosnia",
    "domena": "Bosnia.pl"
  },
  {
    "kod": "CL",
    "nazwa_pl": "Chile",
    "nazwa": "chile",
    "domena": "Chile.info.pl"
  },
  {
    "kod": "DK",
    "nazwa_pl": "Dania",
    "nazwa": "dania",
    "domena": "Dania.info.pl"
  },
  {
    "kod": "AR",
    "nazwa_pl": "Argentyna",
    "nazwa": "argentyna",
    "domena": "Argentyna.info.pl"
  },
  {
    "kod": "NL",
    "nazwa_pl": "Holandia",
    "nazwa": "holandia",
    "domena": "Holandia.info.pl"
  },
  {
    "kod": "FL",
    "nazwa_pl": "Finlandia",
    "nazwa": "finlandia",
    "domena": "Finlandia.info.pl"
  },
  {
    "kod": "LT",
    "nazwa_pl": "Litwa",
    "nazwa": "litwa",
    "domena": "Litwa.info.pl"
  },
  {
    "kod": "BZ",
    "nazwa_pl": "Belize",
    "nazwa": "belize",
    "domena": "Belize.com.pl"
  },
  {
    "kod": "NO",
    "nazwa_pl": "Norwegia",
    "nazwa": "norwegia",
    "domena": "Norwegia.info.pl"
  },
  {
    "kod": "IS",
    "nazwa_pl": "Islandia",
    "nazwa": "islandia",
    "domena": "Islandia.info.pl"
  },
  {
    "kod": "BE",
    "nazwa_pl": "Belgia",
    "nazwa": "belgia",
    "domena": "Belgia.info.pl"
  },
  {
    "kod": "CO",
    "nazwa_pl": "Kolumbia",
    "nazwa": "kolumbia",
    "domena": "Kolumbia.net.pl"
  },
  {
    "kod": "KR",
    "nazwa_pl": "Karaiby",
    "nazwa": "karaiby",
    "domena": "Karaiby.pl"
  },
  {
    "kod": "TH",
    "nazwa_pl": "Tajlandia",
    "nazwa": "tajlandia",
    "domena": "Tajlandia.com.pl"
  },
  {
    "kod": "IZ",
    "nazwa_pl": "Izrael",
    "nazwa": "izrael",
    "domena": "Izrael.pl"
  },
  {
    "kod": "US",
    "nazwa_pl": "Stany Zjednoczone",
    "nazwa": "stanyzjednoczone",
    "domena": "StanyZjednoczone.pl"
  },
  {
    "kod": "CH",
    "nazwa_pl": "Szwajcaria",
    "nazwa": "szwajcaria",
    "domena": "Szwajcaria.com.pl"
  },
  {
    "kod": "CN",
    "nazwa_pl": "Chiny",
    "nazwa": "chiny",
    "domena": "Chiny.com.pl"
  },
  {
    "kod": "IN",
    "nazwa_pl": "Indie",
    "nazwa": "indie",
    "domena": "Indie.com.pl"
  },
  /*{
    "kod": "AU",
    "nazwa_pl": "Australia",
    "nazwa": "australia",
    "domena": "Australia.info.pl"
  },*/
  {
    "kod": "JO",
    "nazwa_pl": "Jordania",
    "nazwa": "jordania",
    "domena": "Jordania.info.pl"
  },
  /*{
    "kod": "CR",
    "nazwa_pl": "Kostaryka",
    "nazwa": "kostaryka",
    "domena": "Kostaryka.com.pl"
  },*/
  {
    "kod": "PE",
    "nazwa_pl": "Peru",
    "nazwa": "peru",
    "domena": "Peru.info.pl"
  },
  /*{
    "kod": "PH",
    "nazwa_pl": "Filipiny",
    "nazwa": "filipiny",
    "domena": "Filipiny.com.pl"
  },*/
  /*{
    "kod": "NZ",
    "nazwa_pl": "Nowa Zelandia",
    "nazwa": "nowazelandia",
    "domena": "NowaZelandia.com.pl"
  },*/
  {
    "kod": "DE",
    "nazwa_pl": "Niemcy",
    "nazwa": "niemcy",
    "domena": "Niemcy.com.pl"
  },
  {
    "kod": "CA",
    "nazwa_pl": "Kanada",
    "nazwa": "kanada",
    "domena": "Kanada.pl"
  },
  {
    "kod": "VE",
    "nazwa_pl": "Wenezuela",
    "nazwa": "wenezuela",
    "domena": "Wenezuela.info.pl"
  },
  {
    "kod": "IE",
    "nazwa_pl": "Irlandia",
    "nazwa": "irlandia",
    "domena": "Irlandia.info.pl"
  },
  {
    "kod": "RU",
    "nazwa_pl": "Rosja",
    "nazwa": "rosja",
    "domena": "Rosja.pl"
  },
  /*{
    "kod": "FJ",
    "nazwa_pl": "Fidzi",
    "nazwa": "fidzi",
    "domena": "Fidzi.pl"
  },*/
  {
    "kod": "GM",
    "nazwa_pl": "Gambia",
    "nazwa": "gambia",
    "domena": "Gambia.com.pl"
  },
  {
    "kod": "GB",
    "nazwa_pl": "Wielka Brytania",
    "nazwa": "wielkabrytania",
    "domena": "WielkaBrytania.com.pl"
  },
  {
    "kod": "CV",
    "nazwa_pl": "Wyspy Zielonego Przylądka",
    "nazwa": "wyspyzielonegoprzyladka",
    "domena": "WyspyZielonegoPrzyladka.pl"
  },
  {
    "kod": "ZA",
    "nazwa_pl": "RPA",
    "nazwa": "rpa",
    "domena": "RPA.pl"
  },
  {
    "kod": "AT",
    "nazwa_pl": "Austria",
    "nazwa": "austria",
    "domena": "Austria.pl"
  },
  {
    "kod": "BL",
    "nazwa_pl": "Bali",
    "nazwa": "bali",
    "domena": "Bali.pl"
  },
  {
    "kod": "BR",
    "nazwa_pl": "Brazylia",
    "nazwa": "brazylia",
    "domena": "Brazylia.com.pl"
  },
  {
    "kod": "BG",
    "nazwa_pl": "Bułgaria",
    "nazwa": "bulgaria",
    "domena": "Bulgaria.pl"
  },
  {
    "kod": "HR",
    "nazwa_pl": "Chorwacja",
    "nazwa": "chorwacja",
    "domena": "Chorwacja.pl"
  },
  {
    "kod": "CY",
    "nazwa_pl": "Cypr",
    "nazwa": "cypr",
    "domena": "Cypr.net.pl"
  },
  {
    "kod": "MN",
    "nazwa_pl": "Czarnogóra",
    "nazwa": "czarnogora",
    "domena": "Czarnogora.pl"
  },
  {
    "kod": "CZ",
    "nazwa_pl": "Czechy",
    "nazwa": "czechy",
    "domena": "Czechy.pl"
  },
  {
    "kod": "EG",
    "nazwa_pl": "Egipt",
    "nazwa": "egipt",
    "domena": "Egipt.info.pl"
  },
  {
    "kod": "AE",
    "nazwa_pl": "Emiraty Arabskie",
    "nazwa": "emiratyarabskie",
    "domena": "EmiratyArabskie.pl"
  },
  {
    "kod": "FR",
    "nazwa_pl": "Francja",
    "nazwa": "francja",
    "domena": "Francja.pl"
  },
  {
    "kod": "GR",
    "nazwa_pl": "Grecja",
    "nazwa": "grecja",
    "domena": "Grecja.com.pl"
  },
  {
    "kod": "HA",
    "nazwa_pl": "Hawaje",
    "nazwa": "hawaje",
    "domena": "Hawaje.com.pl"
  },
  {
    "kod": "ES",
    "nazwa_pl": "Hiszpania",
    "nazwa": "hiszpania",
    "domena": "Hiszpania.com.pl"
  },
  {
    "kod": "KE",
    "nazwa_pl": "Kenia",
    "nazwa": "kenia",
    "domena": "Kenia.info.pl"
  },
  {
    "kod": "BA",
    "nazwa_pl": "Majorka",
    "nazwa": "majorka",
    "domena": "Majorka.com.pl"
  },
  {
    "kod": "MD",
    "nazwa_pl": "Malediwy",
    "nazwa": "malediwy",
    "domena": "Malediwy.com.pl"
  },
  {
    "kod": "MY",
    "nazwa_pl": "Malezja",
    "nazwa": "malezja",
    "domena": "Malezja.info.pl"
  },
  {
    "kod": "MA",
    "nazwa_pl": "Maroko",
    "nazwa": "maroko",
    "domena": "Maroko.com.pl"
  },
  {
    "kod": "MU",
    "nazwa_pl": "Mauritius",
    "nazwa": "mauritius",
    "domena": "Mauritius.pl"
  },
  {
    "kod": "MX",
    "nazwa_pl": "Meksyk",
    "nazwa": "meksyk",
    "domena": "Meksyk.com.pl"
  },
  {
    "kod": "PO",
    "nazwa_pl": "Polinezja",
    "nazwa": "polinezja",
    "domena": "Polinezja.pl"
  },
  {
    "kod": "PT",
    "nazwa_pl": "Portugalia",
    "nazwa": "portugalia",
    "domena": "Portugalia.com.pl"
  },
  {
    "kod": "RO",
    "nazwa_pl": "Rumunia",
    "nazwa": "rumunia",
    "domena": "Rumunia.info.pl"
  },
  {
    "kod": "SC",
    "nazwa_pl": "Seszele",
    "nazwa": "seszele",
    "domena": "Seszele.com.pl"
  },
  {
    "kod": "SK",
    "nazwa_pl": "Słowacja",
    "nazwa": "slowacja",
    "domena": "Slowacja.com.pl"
  },
  {
    "kod": "SI",
    "nazwa_pl": "Słowenia",
    "nazwa": "slowenia",
    "domena": "Slowenia.info.pl"
  },
  {
    "kod": "SL",
    "nazwa_pl": "Sri Lanka",
    "nazwa": "srilanka",
    "domena": "SriLanka.com.pl"
  },
  {
    "kod": "TZ",
    "nazwa_pl": "Tanzania",
    "nazwa": "tanzania",
    "domena": "Tanzania.pl"
  },
  {
    "kod": "TN",
    "nazwa_pl": "Tunezja",
    "nazwa": "tunezja",
    "domena": "Tunezja.com.pl"
  },
  {
    "kod": "TK",
    "nazwa_pl": "Turcja",
    "nazwa": "turcja",
    "domena": "Turcja.com.pl"
  },
  {
    "kod": "HU",
    "nazwa_pl": "Węgry",
    "nazwa": "wegry",
    "domena": "Wegry.biz.pl"
  },
  {
    "kod": "IT",
    "nazwa_pl": "Włochy",
    "nazwa": "wlochy",
    "domena": "Wlochy.pl"
  },
  {
    "kod": "CI",
    "nazwa_pl": "Wyspy Kanaryjskie",
    "nazwa": "wyspykanaryjskie",
    "domena": "WyspyKanaryjskie.pl"
  },
  {
    "kod": "RS",
    "nazwa_pl": "Serbia",
    "nazwa": "serbia",
    "domena": "Serbia.pl"
  },
  /*{
    "kod": "GT",
    "nazwa_pl": "Gwatemala",
    "nazwa": "gwatemala",
    "domena": "Gwatemala.com.pl"
  },*/
  /*{
    "kod": "BO",
    "nazwa_pl": "Boliwia",
    "nazwa": "boliwia",
    "domena": "Boliwia.pl"
  },
  {
    "kod": "IR",
    "nazwa_pl": "Iran",
    "nazwa": "iran",
    "domena": "Iran.net.pl"
  },*/
  {
    "kod": "NA",
    "nazwa_pl": "Namibia",
    "nazwa": "namibia",
    "domena": "Namibia.pl"
  },
  {
    "kod": "MG",
    "nazwa_pl": "Malta-Gozo",
    "nazwa": "malta-gozo",
    "domena": "Malta-Gozo.pl"
  },
  {
    "kod": "MG",
    "nazwa_pl": "Malta-Gozo",
    "nazwa": "malta",
    "domena": "Malta-Gozo.pl"
  },
  {
    "kod": "SE",
    "nazwa_pl": "Szwecja",
    "nazwa": "szwecja",
    "domena": "Szwecja.info.pl"
  },
  {
    "kod": "LV",
    "nazwa_pl": "Łotwa",
    "nazwa": "lotwa",
    "domena": "Lotwa.info.pl"
  },
  {
    "kod": "EE",
    "nazwa_pl": "Estonia",
    "nazwa": "estonia",
    "domena": "Estonia.info.pl"
  },
  {
    "kod": "MK",
    "nazwa_pl": "Macedonia",
    "nazwa": "macedonia",
    "domena": "Macedonia.net.pl"
  }/*,
  {
    "kod": "HO",
    "nazwa_pl": "Honduras",
    "nazwa": "honduras",
    "domena": "Honduras.net.pl"
  }*/
]
}
